module.exports = __webpack_public_path__ + "static/media/95.99f3cc95.png";